// extracted by mini-css-extract-plugin
export var dropdown = "_ry-0";
export var imageWrapper = "_ry-3";
export var itemNameContainer = "_ry-1";
export var productImage = "_ry-2";
export var spinnerWrapper = "_ry-4";